import {
  PosterImage,
  PosterStudioCapabilities,
  PosterStudioSave,
  PosterStudioShare,
} from '@euler/model/poster-studio';
import Toast from 'react-native-root-toast';

/** A browser cannot post to 朋友圈; it downloads. */
export const kPosterStudioCapabilities: PosterStudioCapabilities = {
  share: false,
  save: true,
  exit: true,
};

function blobOf(image: PosterImage): Blob {
  if (image.kind === 'bytes')
    return new Blob([image.bytes], { type: image.format });
  const binary = atob(image.base64);
  const bytes = new Uint8Array(binary.length);
  for (let at = 0; at < binary.length; at++) bytes[at] = binary.charCodeAt(at);
  return new Blob([bytes], { type: image.format });
}

function download(image: PosterImage, name: string) {
  const url = URL.createObjectURL(blobOf(image));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = name;
  anchor.click();
  // After the click has handed the URL to the download.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

/** Saves by downloading; sharing is never offered here (see capabilities). */
export async function deliverPosters(
  event: PosterStudioShare | PosterStudioSave,
): Promise<void> {
  const several = event.images.length > 1;
  event.images.forEach((image, at) => {
    const extension = image.format === 'image/png' ? 'png' : 'jpg';
    download(image, `朋友圈海报${several ? `-${at + 1}` : ''}.${extension}`);
  });
  Toast.show(several ? `已保存 ${event.images.length} 张图片` : '已保存图片', {
    duration: 1500,
    position: Toast.positions.BOTTOM,
  });
}
